import React, { useEffect, useRef } from "react";
import Chart from "chart.js/auto";

const CardBarChart = ({ labelsData, dataData }) => {
  const chartRef = useRef(null);
  const chartInstance = useRef(null);

  useEffect(() => {
    if (!chartRef.current || labelsData.length === 0 || dataData.length === 0) return;

    // Destruir gráfico previo si existe
    if (chartInstance.current) {
      chartInstance.current.destroy();
    }

    chartInstance.current = new Chart(chartRef.current, {
      type: "bar",
      data: {
        labels: labelsData,
        datasets: [
          {
            label: "Total Equipos",
            backgroundColor: '#e0920cff',
            borderColor: "#4c51bf",
            data: dataData,
            fill: false,
            barThickness: 8,
          },
        ],
      },
      options: {
        maintainAspectRatio: false,
        responsive: true,
        plugins: {
          legend: {
            display: false,
          },
        },
        scales: {
          x: { grid: { display: false } },
          y: { grid: { display: false } },
        },
      },
    });
  }, [labelsData, dataData]);

  return (


    <div className="relative flex flex-col min-w-0 break-words bg-white w-full mb-6 shadow-lg rounded">
          <div className="rounded-t mb-0 px-4 py-3 bg-transparent">
      <div className="flex flex-wrap items-center">
        <div className="relative w-full max-w-full flex-grow flex-1">
          <h6 className="uppercase text-blueGray-400 mb-1 text-xs font-semibold">
            Ocupación
          </h6>
          <h2 className="text-blueGray-700 text-xl font-semibold">
            Equipos
          </h2>
        </div>
      </div>
    </div>
      <div className="p-4 flex-auto">
        {labelsData.length === 0 || dataData.length === 0 ? (
          <p className="text-center text-gray-500">Sin datos</p>
        ) : (
          <div className="relative h-350-px">
            <canvas ref={chartRef}></canvas>
          </div>
        )}
      </div>
    </div>
  );
};

export default CardBarChart;
